export const API_KEY = 'jTAAZCA5';
export const API_KEY_ALL = 'P@bl1k.bit';
export const SESSION_STORAGE_KEY = 'SESSION_ID';
export const BASE_URL = 'https://bitbookapi.azurewebsites.net/api/';
export const IMG_PLACEHOLDER = 'https://www.maintenanceconnection.com/website/wp-content/uploads/2014/10/slideshow-placeholder-300x300.jpg';
export const IMG_PLACEHOLDER_ICON = 'https://via.placeholder.com/100x75';
export const SESSION_STORAGE_USER_KEY = 'USER_ID';
export const BITBOOK_INFO_1 = 'BitBook is a popular free social networking website that allows registered users to create profiles, upload photos and video, and keep in touch with friends, family and colleagues.';
export const BITBOOK_INFO_2 = 'According to statistics from the Public research, Internet users within Serbia spend more time on BitBook than any other website.';


// WEBPACK FOOTER //
// ./src/constants.js